module.exports = __webpack_public_path__ + "img/64.dd3448c1.jpg";